'use client';

import React from 'react';
import ImageOnlySlider, {ImageSliderProps} from 'components/commercetools-ui/organisms/content/image-only-slider';
import { TasticProps } from 'frontastic/tastics/types';


const ImageOnlySliderTastic  = ({ data }: TasticProps<ImageSliderProps>) => {
  return <ImageOnlySlider data={data?.data?.dataSource} />;
};

export default ImageOnlySliderTastic;